var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            "max-height": "50vh",
            border: "",
            "row-class-name": _vm.tableRowClassName,
            data: _vm.tableData,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "name",
              "min-width": "150",
              "show-overflow-tooltip": "",
              "class-name": "file-name-cell",
              label: _vm.$t("DOWNLOAD_FILE_NAME"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    !_vm.hasPermission("download") ||
                    (_vm.getUser.userType === "2" &&
                      !_vm.downloadAble &&
                      scope.row.uploadBy &&
                      scope.row.uploadBy.indexOf("@") !== -1 &&
                      scope.row.uploadBy.indexOf(_vm.curUserName) == -1)
                      ? _c("span", [_vm._v(_vm._s(scope.row.name))])
                      : _c(
                          "span",
                          {
                            class: `file-name ${
                              _vm.canDownload ? "can-download" : ""
                            }`,
                            on: {
                              click: function ($event) {
                                return _vm.onFileDownload(scope.row)
                              },
                            },
                          },
                          [
                            _vm.canDownload
                              ? _c("i", { staticClass: "el-icon-download" })
                              : _vm._e(),
                            _vm._v(
                              "\n                      " +
                                _vm._s(scope.row.name) +
                                "\n                  "
                            ),
                          ]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "size",
              "show-overflow-tooltip": "",
              label: _vm.$t("DOWNLOAD_SIZE"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("fileSize")(scope.row.size))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "downloadDate",
              width: "125",
              "show-overflow-tooltip": "",
              label: _vm.$t("DOWNLOAD_TIME"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "downloadBy",
              width: "125",
              "show-overflow-tooltip": "",
              label: _vm.$t("DOWNLOAD_BY"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "uploadDate",
              width: "150",
              "show-overflow-tooltip": "",
              label: _vm.$t("UPLOAD_TIME"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "uploadBy",
              "show-overflow-tooltip": "",
              label: _vm.$t("UPLOAD_BY"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "action",
              width: "80",
              "show-overflow-tooltip": "",
              align: "center",
              label: _vm.$t("COMMON_DELETE"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    !_vm.noAuthority(scope.row)
                      ? _c("i", {
                          staticClass: "el-icon-delete delete",
                          on: {
                            click: function ($event) {
                              return _vm.onDeleteClick(scope.row)
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }